import t from "../cjs/index.js";
const o = t.default || t;
export {
  o as default
};
//# sourceMappingURL=index.js.map
